export default __webpack_public_path__ + "static/media/appleStore.6be0c9a9.png";